interface SessionIdRef {
  current: string | null;
}

interface SessionNavigationControls {
  setActiveSessionId: (id: string | null) => void;
  activeSessionIdRef: SessionIdRef;
  setActiveProjectSessionId: (id: string | null) => void;
  navigate: (path: string) => void;
}

/**
 * A project task chat is hosted on a project route, so its parent session is
 * tracked separately from the normal `/session/:id` selection. Thread asides
 * must use that task session as their provenance parent while the project
 * workspace is active.
 */
export function resolveThreadPanelParentSessionId(
  isProjectsWorkspaceRoute: boolean,
  activeSessionId: string | null,
  activeProjectSessionId: string | null,
): string | null {
  return isProjectsWorkspaceRoute ? activeProjectSessionId : activeSessionId;
}

/**
 * Publish normal-session state before changing Wouter's external location
 * store. Wouter may render the new route immediately, so reversing this order
 * would briefly pair that route with the previously active session.
 */
export function navigateToSession(
  id: string | null,
  controls: SessionNavigationControls,
): void {
  controls.setActiveSessionId(id);
  controls.activeSessionIdRef.current = id;
  controls.setActiveProjectSessionId(null);
  controls.navigate(id ? `/session/${id}` : "/");
}
